import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { compose, branch, lifecycle, renderComponent } from 'recompose';

import authHOC from '../Components/AuthHOC';
import Spinner from '../Components/Spinner';
import ModuleView from './Components/ModuleView';
import { withRouter } from 'react-router-dom';

import {
  saveVersionRequest,
  overwriteVersionRequest,
  resetSaveEditForm,
} from '../redux/reducers/savedVersions';

import {
  getClientBackGroundRequest,
  toggleSaveEditPopup,
  toggleRefererPage,
} from '../redux/reducers/view';
import { authAdminRequest, authUserRequest, getTokenFromCookies } from '../redux/reducers/login';

import {
  getUserProgramsFullRequest,
} from '../redux/reducers/userProgramsFull';



import { selectedContentItem, getAllThinkTools, getAllThinkToolsAndJournals, getSelectedThinktool } from '../redux/selectors';
import VersionView from './Components/VersionView';
import { connectedUsersRequest } from '../redux/reducers/connectedUsers';
import { dropdownsRequest } from '../redux/reducers/dropdowns';

const Versions = () => <VersionView />;

const mapStateToProps = state => ({
  loginReducer: state.loginReducer,
  view: state.viewReducer,
  savedVersions: state.savedVersionsReducer,
  userProgramsFull: state.userProgramsFullReducer,
  getAllThinkTools: getAllThinkTools(state),
  getSelectedThinktool: getSelectedThinktool(state)
});

const mapDispatchToProps = dispatch => ({
  getToken: token => dispatch(getTokenFromCookies(token)),
  authUser: () => dispatch(authUserRequest()),
  authAdmin: (obj) => dispatch(authAdminRequest(obj)),
  getClientBackGroundRequest: () => dispatch(getClientBackGroundRequest()),
  toggleSaveEditPopup: value => dispatch(toggleSaveEditPopup(value)),
  toggleRefererPage: value => dispatch(toggleRefererPage(value)),
  overwriteVersionRequest: () => dispatch(overwriteVersionRequest()),
  saveVersionRequest: () => dispatch(saveVersionRequest()),
  getUserProgramsFullRequest: () => dispatch(getUserProgramsFullRequest()),
  connectedUsersRequest: () => dispatch(connectedUsersRequest()),
  dropdownsRequest: () => dispatch(dropdownsRequest()),
});

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  authHOC,
  lifecycle({
    componentWillMount() {
      const {
        loginReducer,
        getClientBackGroundRequest,
        view,
        savedVersions,
        toggleSaveEditPopup,
        toggleRefererPage,
        userProgramsFull,
        getSelectedThinktool
      } = this.props;
      {}
     
      if (savedVersions.pathToSaveVersion !== null) {
        
        var content = getSelectedThinktool 
        
        if(content.type=='ThinkTool'){
          toggleSaveEditPopup(true);
        }else{
          
        }
      }

    },
    componentWillReceiveProps(nextProps) {
      const { loginReducer, getClientBackGroundRequest, view, userProgramsFull } = nextProps
    },
  }),
 
)(Versions);

Versions.propTypes = {
  view: PropTypes.instanceOf(Object),
};
